const maxZoom = Number(process.env.VUE_APP_MAP_TILE_MAX_ZOOM || 18);

export default {
  urlTemplate: process.env.VUE_APP_MAP_TILE_URL || 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
  attribution:
    process.env.VUE_APP_MAP_TILE_ATTRIBUTION ||
    '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap</a>',
  maxZoom: Number.isFinite(maxZoom) && maxZoom > 0 ? maxZoom : 18,
};
